import {
    Button,
    Col,
    Drawer,
    Form,
    Input,
    InputNumber,
    Row,
    Select,
    notification,
    UploadFile, Upload, Modal
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import {Option} from 'antd/es/mentions';
import React, {useEffect, useState} from 'react';
import {ActionType} from '../../constants/actionType';
import {createEpisode, updateEpisode} from '../../helpers/api/story';
import {RcFile, UploadProps} from "antd/es/upload";
import {Icon} from "ts-react-feather-icons";
import './EpisodeDrawer.scss';
import {convertToWebP} from "../../utils/image";

const episodeDrawerValidation = {
    name: [
        {required: true, message: 'Name is required'},
        {max: 100, message: 'Name must be less than 100 characters'},
    ],
    description: [
        {required: true, message: 'Description is required'},
        {max: 5000, message: 'Description must be less than 5000 characters'},
    ],
    level: [
        {required: true, message: 'Level is required'},
    ],
    status: [
        {required: true, message: 'Status is required'},
    ],
}

const EpisodeDrawer = ({
                           story,
                           drawerVisibility,
                           setdDrawerVisibility,
                           episodeDetail,
                           setEpisodeDetail,
                           actionType,
                           setActionType,
                           onSuccess,
                           onFailure
                       }: any) => {

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);

    const [submittables, setSubmittable] = useState<boolean>(false);
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

    const [status, setStatus] = useState<string>("inactive");
    const [sounds, setSounds] = useState<UploadFile[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewSound, setPreviewSound] = useState<string | undefined>("");
    const [previewTitle, setPreviewTitle] = useState("");

    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }
        setPreviewSound(file.url || (file.preview as string));
        setPreviewTitle(file.name || "Audio Preview");
        setPreviewOpen(true);
    };

    const handleChange: UploadProps["onChange"] = ({fileList: newFileList}) =>
        setSounds(newFileList);

    const uploadButton = (
        <div>
            <Icon name="plus" size={16}/>
            <div style={{marginTop: 8}}>Upload</div>
        </div>
    );

    const [videos, setVideos] = useState<UploadFile[]>([]);
    const [previewOpenVideo, setPreviewOpenVideo] = useState(false);
    const [previewVideo, setPreviewVideo] = useState<string | undefined>("");
    const [previewTitleVideo, setPreviewTitleVideo] = useState("");
    const [videoType, setVideoType] = useState<string>("video");


    const handleCancelVideo = () => setPreviewOpenVideo(false);

    const handlePreviewVideo = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }
        setPreviewVideo(file.url || (file.preview as string));
        const type = file.name.split(".").pop();
        if (type === "mp4") {
            setVideoType("video");
        } else {
            setVideoType("image");
        }
        setPreviewTitleVideo(file.name || "Audio Preview");
        setPreviewOpenVideo(true);
    };

    const handleChangeVideo: UploadProps['onChange'] = async ({ fileList: newFileList }) => {
        try {
            // Tạo một danh sách fileList tạm thời để hiển thị ngay lập tức
            const tempFileList = newFileList.map(file => ({
                ...file,
                status: 'uploading' as UploadFile<any>['status'],
            }));
            setVideos(tempFileList as UploadFile<any>[]);

            // Convert files sang WebP
            const webpFiles = await Promise.all(
                newFileList.map(async (file) => {
                    // Chỉ convert nếu là file mới upload
                    if (!file.originFileObj) {
                        return file;
                    }

                    try {
                        const webpFile = await convertToWebP(file.originFileObj as RcFile);
                        // Tạo preview URL cho file đã convert
                        const previewUrl = await getBase64(webpFile);
                        return {
                            ...file,
                            originFileObj: webpFile,
                            status: 'done',
                            preview: previewUrl,
                            url: previewUrl,
                            fileName: webpFile.name
                        };
                    } catch (error) {
                        return {
                            ...file,
                            status: 'error',
                            error: new Error('Failed to convert image')
                        };
                    }
                })
            );

            setVideos(webpFiles as UploadFile<any>[]);
        } catch (error) {
            console.error('Error processing files:', error);
            notification.error({
                message: 'Error',
                description: 'Failed to process image'
            });
        }
    };


    const [api, contextHolder] = notification.useNotification();
    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    useEffect(() => {
        form.validateFields({validateOnly: true})
            .then(
                () => {
                    setSubmittable(true)
                },
                () => {
                    setSubmittable(false)
                },
            );
    }, [formValueObj]);

    useEffect(() => {
        if (actionType === ActionType.CREATE) {
            form.resetFields();
            setSubmittable(false);
            form.setFieldValue("status", "inactive");
            setSounds([]);
            setVideos([]);
            setStatus("inactive");
        }
    }, [actionType]);

    useEffect(() => {
        setSounds([]);
        setVideos([]);
        if (!episodeDetail) {
            form.setFieldValue("status", "inactive");
            setStatus("inactive");
            return;
        }
        if (episodeDetail?.soundBackgroundUrl && episodeDetail?.soundBackgroundUrl?.trim().length > 0) {
            const urlTemp = episodeDetail?.soundBackgroundUrl.split("/");
            setSounds([{
                uid: "1",
                name: urlTemp[urlTemp.length - 1],
                status: 'done',
                url: episodeDetail?.soundBackgroundUrl
            }]);
        }
        if (episodeDetail?.defaultBackgroundUrl && episodeDetail?.defaultBackgroundUrl?.trim().length > 0) {
            const urlTemp = episodeDetail?.defaultBackgroundUrl.split("/");
            setVideos([{
                uid: "1",
                name: urlTemp[urlTemp.length - 1],
                status: 'done',
                url: episodeDetail?.defaultBackgroundUrl
            }]);
        }
        setStatus(episodeDetail.status);
        form.setFieldsValue({...episodeDetail});

    }, [episodeDetail]);


    const onClose = () => {
        form.resetFields();
        setEpisodeDetail(null);
        form.setFieldValue("status", "inactive");
        setStatus("inactive");
        setSubmittable(false);
        setSounds([]);
        setVideos([]);
        setdDrawerVisibility(false);
        setActionType("");
    }

    const saveEpisode = async () => {
        try {
            setLoadingBtn(true);
            form.validateFields();
            let response;
            const requestModel: any = {
                name: formValueObj.name?.trim(),
                level: formValueObj.level || 1,
                description: formValueObj.description?.trim(),
                status: status,
            }

            const formData = new FormData();

            if (actionType === ActionType.CREATE) {
                formData.append("data", JSON.stringify(requestModel));
                if (sounds?.[0]) {
                    formData.append("files", sounds?.[0]?.originFileObj as RcFile, `${sounds?.[0]?.name.split(".")[0]}_sound`);
                }
                if (videos?.[0]) {
                    formData.append("files", videos?.[0]?.originFileObj as RcFile, `${videos?.[0]?.name.split(".")[0]}_video`);
                }
                response = await createEpisode(story.id, formData);
            } else {
                if (sounds?.[0] && sounds?.[0].url === episodeDetail.soundBackgroundUrl) {
                    requestModel["soundBackgroundUrl"] = episodeDetail.soundBackgroundUrl;
                } else {
                    if (sounds?.[0]) {
                        formData.append("files", sounds?.[0]?.originFileObj as RcFile, `${sounds?.[0]?.name.split(".")[0]}_sound`);
                    }
                }
                if (videos?.[0] && videos?.[0].url === episodeDetail.defaultBackgroundUrl) {
                    requestModel["defaultBackgroundUrl"] = episodeDetail.defaultBackgroundUrl;
                } else {
                    if (videos?.[0]) {
                        formData.append("files", videos?.[0]?.originFileObj as RcFile, `${videos?.[0]?.name.split(".")[0]}_video`);
                    }
                }
                formData.append("data", JSON.stringify(requestModel));
                response = await updateEpisode(story.id, episodeDetail.id, formData);
            }

            setLoadingBtn(false);
            if (response?.status === 200) {
                onSuccess();
                onClose();
                return;
            }
        } catch (err) {
            console.log(err);
            onFailure(err);
        }
        setLoadingBtn(false);
    }

    return (
        <Drawer
            title={(actionType === ActionType.UPDATE ? "Update" : "Create") + " a episode"}
            className='episode-drawer'
            width={750}
            onClose={() => {
                setdDrawerVisibility(false)
            }}
            open={drawerVisibility}
            closeIcon={false}
            footer={
                <div className='d-flex justify-content-center'>
                    <Button onClick={saveEpisode} type="primary" className='me-3' disabled={!submittables}
                            loading={loadingBtn}>
                        Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </div>
            }
        >
            {contextHolder}
            <Form layout="vertical" autoComplete='off' form={form}>
                <Row gutter={16} className='mb-3'>
                    <Col span={24}>
                        <Form.Item name="video" label="Video or Image for home">
                            <Upload
                                listType="picture"
                                accept="video/*,image/*"
                                onPreview={handlePreviewVideo}
                                onChange={handleChangeVideo}
                                beforeUpload={() => false}
                                fileList={videos}
                            >
                                {videos.length >= 1 ? null : uploadButton}
                            </Upload>
                            <Modal
                                open={previewOpenVideo}
                                footer={null}
                                onCancel={handleCancelVideo}
                            >
                                {videoType === 'video' ? (
                                    <video controls style={{width: "100%"}}>
                                        <source src={previewVideo} type="video/mp4"/>
                                        Your browser does not support the video tag.
                                    </video>
                                ) : (
                                    <img alt="example" style={{width: '100%'}} src={previewVideo}/>
                                )}
                            </Modal>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-3'>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={episodeDrawerValidation.name}
                        >
                            <Input placeholder="Please enter name"/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="level"
                            label="Level"
                            rules={episodeDrawerValidation.level}
                        >
                            <InputNumber placeholder="Please enter level" min={1} max={100} style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-3'>
                    <Col span={12}>
                        <Form.Item
                            name="status"
                            label="Status"
                            rules={episodeDrawerValidation.status}
                        >
                            <Select placeholder="Please select a status" value={status} onChange={(e) => setStatus(e)}>
                                <Option value="active">Active</Option>
                                <Option value="inactive">Inactive</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="description"
                            label="Description"
                            rules={episodeDrawerValidation.description}
                        >
                            <TextArea rows={4} placeholder="Enter description" maxLength={5000}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item name="sound" label="Background Music">
                            <Upload
                                listType="picture"
                                accept="audio/*"
                                onPreview={handlePreview}
                                onChange={handleChange}
                                beforeUpload={() => false}
                                fileList={sounds}
                            >
                                {sounds.length >= 1 ? null : uploadButton}
                            </Upload>
                            <Modal
                                open={previewOpen}
                                title={previewTitle}
                                footer={null}
                                onCancel={handleCancel}
                            >
                                <audio controls style={{width: "100%"}}>
                                    <source src={previewSound} type="audio/mpeg"/>
                                    Your browser does not support the audio element.
                                </audio>
                            </Modal>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    )

}

export default EpisodeDrawer;
